var map = {
	"./": 55,
	"./attachments": 121,
	"./attachments.js": 121,
	"./dialogs": 122,
	"./dialogs.js": 122,
	"./index": 55,
	"./index.js": 55,
	"./user": 123,
	"./user.js": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 200;